import { SAGA_ACTIONS } from '../../../_config'
import { ErrorResponse, SuccessResponse } from '../apiTypes'
import { useApiCall } from '../appApiCallHook'

export function useSelfServiceApi() {
    const callApi = useApiCall()

    const getSelfServiceDropDown = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.SELF_SERVICE.GET_SELF_SERVICE_DROPDOWN_DATA, data, onSuccess, onError)
    }
    const getSelfServiceData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.SELF_SERVICE.GET_SELF_SERVICE_DATA, data, onSuccess, onError)
    }

    const getSelfServiceDataColumn = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.SELF_SERVICE.GET_SELF_SERVICE_DATA_COLUMN, data, onSuccess, onError)
    }
    const saveSelfServiceData = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.SELF_SERVICE.SAVE_SELFSERVICE_DATA, data, onSuccess, onError)
    }

    return {
        getSelfServiceDropDown,
        getSelfServiceData,
        getSelfServiceDataColumn,
        saveSelfServiceData,
    }
}
